import React from 'react';
import { Stack, Typography } from '@mui/material';

export interface CostSummaryItem {
    label: string;
    value: string;
    color?: string; // ej. 'error.main' cuando el margen es negativo
}

// Resumen de costeo en vivo, pensado para vivir FIJO en el DialogActions de los modales
// del Catálogo 2.0 (visible sin scroll mientras se editan cantidades).
export const CostSummaryBar: React.FunctionComponent<{ items: CostSummaryItem[] }> = ({ items }) => {
    return (
        <Stack
            direction="row"
            flexWrap="wrap"
            columnGap={3}
            rowGap={0.5}
            alignItems="center"
            bgcolor="#F6F8FA"
            borderRadius={2}
            px={2}
            py={1}
            width="100%"
        >
            {items.map((item) => (
                <Stack key={item.label} direction="row" spacing={0.75} alignItems="baseline">
                    <Typography variant="caption" color="text.secondary">
                        {item.label}
                    </Typography>
                    <Typography variant="body2" fontWeight={700} color={item.color || 'text.primary'}>
                        {item.value}
                    </Typography>
                </Stack>
            ))}
        </Stack>
    );
};
